module.exports = __webpack_public_path__ + "img/Bitmap-2.37900ec0.png";